import React, { useEffect, useState } from 'react';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';
import liracrypt from '../Liracrypt/liracrypt';
import { Button, Spin, notification } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import ApiErrorComp from '../ApiErrorComp/ApiErrorComp';

const JSONEditor = ({
    data,
    url,
    method,
}) => {
    const [jsonData, setJSONData] = useState({});
    const [isJSONValid, setIsJSONValid] = useState(false);
    useEffect(() => {
        if (method === 'GET') {
            liracrypt.get(url, data)
                .then(response => {
                    console.log(response);
                    setJSONData(response.data.data);
                    setIsJSONValid(true);
                }).catch(err => {
                    console.log(err);
                })
        } else {
            let formData = new FormData();
            Object.keys(data).forEach(key => {
                formData.append(key, data[key]);
            });

            liracrypt.uploadFile(url, formData)
                .then(response => {
                    console.log(response);
                    setJSONData(response.data.data);
                    setIsJSONValid(true);
                }).catch(err => {
                    console.log(err);
                })
        }

    }, [data]);
    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

    const saveJSON = () => {
        if (!isJSONValid) return;
        liracrypt.post('/config/jsoneditor', { json: jsonData, queryElements: data })
            .then(response => {
                notification.success({
                    message: response?.data?.message
                        ? response?.data?.message
                        : "JSON saved successfully",
                });
            }).catch(err => {
                console.log(err);
                ApiErrorComp(err);
            })
    };

    return jsonData ? (
        <div className="json-editor">
            {/* <JSONEditor
                width={'100%'}
                data={jsonData}
                onChange={setJSONData}
            /> */}
            <JSONInput
                locale={locale}
                placeholder={jsonData}
                height='500px'
                width='100%'
                onChange={(data) => {
                    if (data.error) {
                        return setIsJSONValid(false);
                    }
                    setIsJSONValid(true);
                    setJSONData(data.jsObject);
                }}
                theme="background"
            />

            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 20 }}>
                <Button onClick={saveJSON} color='primary'>Submit</Button>
            </div>
        </div>
    ) : (
        <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
            <Spin indicator={antIcon} />
        </div>
    )
};

export default JSONEditor;